module.exports = __webpack_public_path__ + "static/media/new_cat_super_pack_FR_285x350.d148ef24.png";